/*
 * @Author: your name
 * @Date: 2019-11-21 18:30:51
 * @LastEditTime: 2024-09-07 18:33:34
 * @LastEditors: mqlpcthree mql_pcthree@163.com
 * @Description: In User Settings Edit
 * @FilePath: /mei_qi_zeroweb_endlyq/src/api/data.js
 */
/**
 * @Auther: Qsan
 * @Date：2018年12月12日 00:22
 * @Desc：数据中心相关接口
 */
import { get, post } from '@common/http'

/**
 * 添加数据
 * @param param
 * @returns {*}
 */
//  工作台获取数据

export const workbenchData = (param) => get('/statistic/workbench-data', param)

// 收入概览
export const income = (param) => get('/statistic/income', param)

// 顾客概览
export const member = (param) => get('/statistic/member', param)

// 会员卡概览
export const memberCard = (param) => get('/statistic/member-card', param)

// 员工业绩汇总统计
export const brokerage = (param) => get('/statistic/brokerage', param)

// 员工业绩汇总列表V1
export const employeeBrokerage = (param) => get('/statistic/employee-brokerage', param)

// 员工业绩汇总列表V2
export const employeeBrokerageData = (param) => get('/statistic/employee-brokerageData', param)

// 员工业绩导出
export const employeeBrokerageExcel = (param) => post('/statistic/employee-brokerage/excel', param)

// 员工提成汇总统计
export const brokerageMonthly = (param) => get('/statistic/brokerage-monthly', param)

// 员工提成汇总统计V2
export const getBrokerageListDataDetail = (param) => get('/statistic/brokerageListDataDetail', param)

// 员工提成汇总列表V1
export const tenantBrokereageMonthly = (param) => get('/statistic/brokerageList', param)

// 员工提成汇总列表V2
export const brokerageListData = (param) => get('/statistic/brokerageListData', param)

// 员工提成导出
export const brokerageMonthlyExcel = (param) => post('/statistic/brokerage-monthly/excel', param)

// 员工项目明细表
// export const employeeDetailsList = (param) => get('/statistic/employeePackage', param)

export const employeeDetailsList = (param) => get('/statistic/employeePackageStatisticNew', param)

// 员工项目分类明细表V1
// export const itemClassifyList = (param) => get('/statistic/employeePackageType', param)

// 员工项目分类明细表V2
export const itemClassifyList = (param) =>
  get('/statistic/employeePackageTypeStatisticTotalData', param)

export const itemClassifyPerformanceMapList = (param) =>
  get('/statistic/employeePackageTypePerformanceMapList', param)

export const itemClassifyCountOrderNum = (param) =>
  get('/statistic/employeePackageTypeCountOrderNum', param)

export const itemClassifyMapList = (param) => get('/statistic/employeePackageTypeMapList', param)

// 员工工资汇总/员工业绩汇总-职位查询
export const brokerageListCount = (param) => get('/statistic/brokerageListCount', param)

// 员工项目分类明细-职位查询
export const employeePackageTypeCount = (param) => get('/statistic/employeePackageTypeCount', param)

// 员工项目明细-查询接口
export const employeePackageStatisticCount = (param) =>
  get('/statistic/employeePackageStatisticCount', param)

// 员工项目明细-查询接口V2
// export const employeePackageStatisticCount = (param) =>
//   get('/statistic/employeePackageStatisticNew', param)

// 员工产品明细
export const productionScheduleList = (param) => get('/statistic/employeeProduct', param)

// 员工产品分类明细表
export const ProductclassificationdetailsList = (param) =>
  get('/statistic/employeeProductType', param)

// 业绩明细列明
export const orderBrokerage = (param) => get('/order-brokerage/get-brokerage-list', param)

// 员工开充卡业绩汇总
export const getBrokerageCard = (param) => get('/statistic/brokerage-card', param)

// 修改分类比例
export const orderPropertyAdd = (param) => post('/order-proportion/add', param)

// 员工业绩汇总
export const employeePerformanceSummary = (param) => get('/statistic/employeeCashAll', param)
// 获取无纸化支付二维码
export const getpaperlessWXPicCode = (param) => get('order/activatePaperless')

// 获取预约支付二维码
export const getActivateAppointmentCode = (param) => get(`/order/activateAppointment?longitude=${param.longitude}&latitude=${param.dimension}`)

// 获取顾客唤醒支付二维码
export const getActivateCustomerCode = () => get('/order/activateCustomer')

// 获取活动推送支付二维码
export const getActivateWxPushCountCode = () => get('/order/activateWxPushCount')

// 员工考勤汇总
export const employeeAttendanceSummary = (param) =>
  post('/workAttendance/getAttendanceStatistics', param)

// 查询部门业绩统计
export const getdepartmentAchievementSummary = (param) =>
  post(`/departmentAchievement/summary`, param)



// WEBPACK FOOTER //
// ./src/api/data.js